<template>
  <div id="page-organisation-view">
    <vx-title-bar :route="$route" :isRTL="$vs.rtl">
      <vs-dropdown
        vs-trigger-click
        class="ml-auto md:block hidden cursor-pointer"
      >
        <vs-button radius icon="icon-more-vertical" icon-pack="feather" />
        <vs-dropdown-menu>
          <vs-dropdown-item>
            <div @click="editRecord" class="flex items-center">
              <feather-icon
                icon="EditIcon"
                class="inline-block mr-2"
                svgClasses="w-4 h-4"
              />
              <span>{{ this.$t("Edit") }}</span>
            </div>
          </vs-dropdown-item>
          <vs-dropdown-item>
            <div @click="confirmDeleteRecord" class="flex items-center">
              <feather-icon
                icon="TrashIcon"
                class="inline-block mr-2"
                svgClasses="w-4 h-4"
              />
              <span>{{ this.$t("Delete") }}</span>
            </div>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </vx-title-bar>
    <vs-alert
      color="danger"
      title="Organisation Not Found"
      :active.sync="organisation_not_found"
    >
      <span>
        Organisation record with id
        <strong>{{ $route.params.organisationId }}</strong> not found.
      </span>
      <span>
        <span>Check</span>
        <router-link
          :to="{ name: 'organisation-list' }"
          class="text-inherit underline"
          >{{ this.$t("Organisation.List") }}</router-link
        >
      </span>
    </vs-alert>

    <div id="organisation-data" v-if="organisation_data">
      <vx-card :title="this.$t('Organisation.Title')" class="mb-base">
        <!-- Organisation -->
        <div class="vx-row">
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">
                  {{ this.$t("Organisation.Name") }}
                </td>
                <td>{{ organisation_data.name }}</td>
              </tr>
            </table>
          </div>
          <!-- Log Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <img :src="organisation_data.logoUrl" class="rounded w-full" />
            </div>
          </div>
        </div>
      </vx-card>
      <vx-card :title="this.$t('Organisation.Users')" class="mb-base">
        <organisation-user-list
          :organisationId="organisation_data.id"
        ></organisation-user-list>
      </vx-card>
    </div>
  </div>
</template>

<script>
import moduleOrganisationManagement from '@/store/organisation-management/moduleOrganisationManagement.js'
import OrganisationUserList from './OrganisationUserList.vue'
import { notifyMixin } from '@/mixins/notifyMixin'

export default {
  mixins: [notifyMixin],
  data () {
    return {
      organisation_data: null,
      organisation_not_found: false
    }
  },
  components: {
    OrganisationUserList
  },
  methods: {
    editRecord () {
      this.$router.push(`/organisation/edit/${this.organisation_data.id}`).catch(() => { })
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete organisation "${this.organisation_data.name}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      this.$store.dispatch('organisationManagement/removeRecord', this.organisation_data.id)
        .then(() => { this.$router.push({ name: 'organisation-list' }); this.showDeleteSuccess() })
        .catch(err => { console.error(err) })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Organisation Deleted',
        text: 'The selected organisation was successfully deleted'
      })
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('ConfirmDelete'),
        text: this.$t('Organisation.DeleteQuestion', { name: this.organisation_data.name }),
        accept: this.deleteRecord,
        acceptText: this.$t('Delete'),
        cancelText: this.$t("Cancel")
      })
    },
    deleteRecord () {
      this.$store.dispatch('organisationManagement/removeRecord', this.organisation_data.id)
        .then(() => {
          this.$router.push({ name: 'organisation-list' })
          this.notifySuccess(this.$t("Organisation.Deleted"))
        })
        .catch(err => { console.error(err) })
    }
  },
  created () {
    // Register Module OrganisationManagement Module
    if (!moduleOrganisationManagement.isRegistered) {
      this.$store.registerModule('organisationManagement', moduleOrganisationManagement)
      moduleOrganisationManagement.isRegistered = true
    }

    const organisationId = this.$route.params.organisationId
    this.$store.dispatch('organisationManagement/fetchOrganisation', organisationId)
      .then(res => {
        this.organisation_data = res.data.organisation
        if (this.organisation_data === null) {
          this.organisation_not_found = true
        }
      })
      .catch(err => {
        if (err.response.status === 404) {
          this.organisation_not_found = true
          return
        }
        console.error(err)
      })
  }
}

</script>

<style lang="scss">
#page-organisation-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
</style>
